function equalHeightTitle_EB(parent_element, target_element, group_size) {
  if (window.innerWidth > 1199) {
    if (parent_element.length > 0) {
      parent_element.each(function (index_parent, parent) {
        const child = $(parent).find(target_element);
        for (let i = 0; i < child.length; i += group_size) {
          const group = child.slice(i, i + group_size);

          let max_height = 0;

          group.each(function () {
            const height = $(this).outerHeight();
            max_height = Math.max(max_height, height);
          });

          group.each(function () {
            $(this).css("min-height", max_height);
          });
        }
      });
    }
  }

  if (window.innerWidth > 991 && window.innerWidth < 1200) {
    group_size = 3;

    if (parent_element.length > 0) {
      parent_element.each(function (index_parent, parent) {
        const child = $(parent).find(target_element);
        for (let i = 0; i < child.length; i += group_size) {
          const group = child.slice(i, i + group_size);

          let max_height = 0;

          group.each(function () {
            const height = $(this).outerHeight();
            max_height = Math.max(max_height, height);
          });

          group.each(function () {
            $(this).css("min-height", max_height);
          });
        }
      });
    }
  }

  if (window.innerWidth > 767 && window.innerWidth < 992) {
    group_size = 2;

    if (parent_element.length > 0) {
      parent_element.each(function (index_parent, parent) {
        const child = $(parent).find(target_element);
        for (let i = 0; i < child.length; i += group_size) {
          const group = child.slice(i, i + group_size);

          let max_height = 0;

          group.each(function () {
            const height = $(this).outerHeight();
            max_height = Math.max(max_height, height);
          });

          group.each(function () {
            $(this).css("min-height", max_height);
          });
        }
      });
    }
  }
}

export { equalHeightTitle_EB };

$(document).ready(function () {
  equalHeightTitle_EB($(".section-contact-box"), $(".box__item__title"), 3);

  equalHeightTitle_EB(
    $(".section-features.two-column"),
    $(".content__title"),
    2
  );
  equalHeightTitle_EB(
    $(".section-features.three-column"),
    $(".content__title"),
    3
  );
  equalHeightTitle_EB(
    $(".section-features.four-column"),
    $(".content__title"),
    4
  );

  equalHeightTitle_EB($(".multiple-column-card"), $(".content__title"), 3);

  equalHeightTitle_EB(
    $(".multiple-column-text-number"),
    $(".content__title"),
    3
  );

  equalHeightTitle_EB(
    $(".section-true-stories-listing"),
    $(".true-stories-content h3"),
    3
  );

  equalHeightTitle_EB(
    $(".section-true-story-listing .blog-listing"),
    $(".blog-post__content .entry-title"),
    3
  );

  equalHeightTitle_EB($(".section-price-table"), $(".plan-card__title"), 2);
});
